import Client from "shopify-buy";

const domain = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN
const storefrontAccessToken = process.env.REACT_APP_SHOPIFY_STORE_KEY

export const shopifyClient = Client.buildClient({
  domain,
  storefrontAccessToken
});
